var Theme = Theme || {};

Theme.ContactUsForm = (function ($) {

    return {
        init: _init
    };

    function _init() {
        handleSubmitClick();
        updateCommentCharsRemainingOnKeyup();
        setCommentCharsRemaining();
    }

    function updateCommentCharsRemainingOnKeyup() {
        $('#Comment').on('keyup', setCommentCharsRemaining);
    }

    function setCommentCharsRemaining() {
        var $comment = $('#Comment');
        var commentMaxLength = $('.comment-max-length').data('maxLength');
        if (!$comment.length) {
            return;
        }
        $('#charRemaining').text(_calcCharsRemaining($comment, commentMaxLength));
    }

    function _calcCharsRemaining($target, maxLength) {
        var currentVal = $target.val();
        var currentLength = currentVal.length;
        if (currentLength > maxLength) {
            $target.val(currentVal.substring(0, maxLength));
            return '0';
        } else {
            return (maxLength - currentLength).toString();
        }
    }

    function handleSubmitClick() {
        $('.widget-contact-us #btnSubmit').on('click', _submitFormData);
    }

    function _submitFormData(e) {
        var $formContainer = $('.widget-contact-us');

        var firstName = $formContainer.find('#FirstName').val();
        var lastName = $formContainer.find('#LastName').val();
        var email = $formContainer.find('#EmailAddress').val();
        var subject = $formContainer.find('#Subject').val();
        var isLibrarian = $formContainer.find('#IsLibrarian').prop('checked');
        var isMember = $formContainer.find('#IsMember').prop('checked');
        var reason = $formContainer.find('#Reason').val();
        var journal = $formContainer.find('#Journal').val();
        var comment = $formContainer.find('#Comment').val();
        var customerNumber = $formContainer.find('#CustomerNumber').val();
        var accessMethod = $formContainer.find('#AccessMethod').val();
        var operatingSystem = $formContainer.find('#OperatingSystem').val();
        var bugDescription = $formContainer.find('#BugDescription').val();
        var recaptchaInfo = SCM.Captcha.GetCaptchaInfo();


        var model = {
            'FirstName': firstName,
            'LastName': lastName,
            'EmailAddress': email,
            'Subject': subject,
            'IsLibrarian': isLibrarian,
            'Reason': reason,
            'Journal': journal,
            'Comment': comment,
            'CaptchaInfo': recaptchaInfo,
            'IsMember': isMember,
            'CustomerNumber': customerNumber,
            'AccessMethod': accessMethod,
            'OperatingSystem': operatingSystem,
            'BugDescription': bugDescription
        };

        var ajaxUrl = '/Common/ContactUsForm';

        e.preventDefault();

        SCM.Ajax.post(ajaxUrl, model)
            .expectActionResultModel()
            .ensureSuccess()
            .then(_handleSuccess)
            .catch(_handleErrors);
    }

    function _handleSuccess(ajaxResult) {
        var $formContainer = $('.widget-contact-us');
        var $successMsgDiv = $formContainer.find('.message-success');
        var $successMsg = $('<div/>');
        var contactUsForm = $formContainer.find('.widget-contact-us-form');

        $.each(ajaxResult.Messages, function (index, value) {
            $successMsg.append(value);
        });

        contactUsForm.addClass('hide');

        $successMsgDiv.html($successMsg.html());
    }

    function _handleErrors(ajaxError) {
        var actionResult = ajaxError.actionResultModel;
        var $form = $('.widget-contact-us-form');

        $('.field-error').text('').hide();
        $form.find('[aria-invalid]').removeAttr('aria-invalid');
        if (actionResult.ValidationErrors) {
            $.each(actionResult.ValidationErrors, function (i, err) {
                $('#' + err.Key + '-error').text(err.Errors[0]).show();
                $('#' + err.Key).attr('aria-invalid', 'true');
            });
            _focusFirstInvalidField($form);
        }

        if (actionResult.Messages !== undefined && actionResult.Messages.length &&
            (!actionResult.ValidationErrors || actionResult.ValidationErrors.length === 0)) {

            var $formContainer = $('.widget-contact-us');
            var $ulObj = $('<ul></ul>');
            var $errorMsgDiv = $formContainer.find('.error-message');

            $.each(actionResult.Messages, function (index, value) {
                $ulObj.append(`<li>${value}</li>`);
            });

            $errorMsgDiv.html($ulObj.html());
        }
    }

    function _focusFirstInvalidField($form) {
        $form.find('[aria-invalid="true"]').first().trigger('focus');
    }

})(jQuery);

